import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  id: "",
  createProposalLoading: false,
  createProposalError: "",
  proposalPayloadFormData: {},
  storeProposalFormData: {
    benefitIllustration: {
      FullName: "",
      productName: "",
      MobileNo: "",
      proposalStatus: "",
      leadStatus: "",
      userId: "",
      lead_Owner_Id: "", //get from store
      lead_Creator_Id: "", //get from store
      leadId: "",
      productId: "",
      riders: [],
      funds: [],
      inputPartialWithdrawal: [],
      formInputs: [
        { key: "@DATEOF_COMMENCEMENT", value: "" },
        { key: "@LI=PI", value: false },
        { key: "@LI_NAME", value: "" },
        { key: "@LI_DOB", value: "" },
        { key: "@LI_ENTRY_AGE", value: "" },
        { key: "@PROPOSER_NAME", value: "" },
        { key: "@PROPOSER_DOB", value: "" },
        { key: "@PROPOSER_AGE", value: "" },
        { key: "@LI_GENDER", value: "" },
        { key: "@PR_PT", value: "" },
        { key: "@PR_PPT", value: "" },
        { key: "@LI_Single/Limited", value: "" },
        { key: "@INPUT_MODE", value: "" },
        { key: "@PR_ANNPREM", value: 0 },
        { key: "@LI_InstallmentPremium", value: "" },
        { key: "@LI_AGEDEATHSUMASSURED", value: 0 },
        { key: "@PR_MATURITYSUMASSURED", value: 0 },
        { key: "@EMR_RATE", value: "" },
        { key: "@RPM", value: "" },
        { key: "@PR_ID", value: "" },
      ],
    },
    einsurance: {
      elinsuranceAccountNumber: "",
      IselinsuranceAccountNumberAvailable: "",
      entities: "",
      nameOfInsuranceRespository: "",
      consentCheck: false,
      consentRemark: "",
    },
  },
};

const createProposalStart = (state, action) => {
  return updateObject(state, {
    storeData: action,
  });
};

const createProposal = (state, action) => {
  //console.log(state, action);

  // //console.log(payload);
  return updateObject(state, {
    proposalLoading: true,
    proposalLoading: false,
    storeProposalFormData: action.payload,
    proposalPayloadFormData: action.payload,
    // leadId: action.storeProposalFormData._id,
    // userId:action.formData.userId,
    successMsg: action.succMsg,
  });
};

const createProposalFail = (state, action) => {
  return updateObject(state, {
    createProposalLoading: false,
    createProposalError: action.error,
    proposalLoading: false,
    errorMessage: action.error,
  });
};

const proposalId = (state, action) => {
  return updateObject(state, {
    id: action.payload,
  });
};

const addProposalBIdata = (state, action) => {
  return updateObject(state, {
    Bi: action.payload,
  });
};

const mandatoryUpload = (state, action) => {
  return updateObject(state, {
    mandatoryDocUpload: action.payload,
  });
};

const editProposalFormData = (state, action) => {
  //console.log("stateEditable---->", state);
  //console.log("ActionEditable---->", action);
  let payload = {
    ...state.storeProposalFormData,
    ...action.storeProposalFormData,
  };
  return updateObject(state, {
    formData: payload,
  });
};

const proposalFormFilling = (state, action) => {
  //console.log("State======>", state);
  //console.log("Actions====>", action);
  return updateObject(state, {
    proposalFormFilling: {
      einsurance: action.payload.lifeinsuranceDetails,
      Details: action.payload.benefitIllustration,
      Personal: action.payload.personalDetails,
      Financial: action.payload.personalDetails,
      Health: action.payload.medicalDetails,
      Nomination: action.payload.nomineeDetails,
      Declaration: action.payload.medicalDetails,
      Proposer: action.payload.misc,
      familyHealth: action.payload.familyhistoryDetails,
    },
  });
};

const storeProposalFormData = (state, action) => {
  //console.log("State===>", state);
  //console.log("Action===>", action);
  return updateObject(state, {
    storeForm: action.storeProposalFormData,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // lead
    case actionTypes.CREATE_PROPOSAL_FORM_START:
      return createProposalStart(state, action);
    case actionTypes.CREATE_PROPOSAL_FORM_SUCCESS:
      return createProposal(state, action);
    case actionTypes.CREATE_PROPOSAL_FORM_FAIL:
      return createProposalFail(state, action);
    // case actionTypes.ADD_PROPOSAL_BI_FORM_DATA:
    //   return addProposalBIdata(state, action);
    // case actionTypes.MANDATORY_DOCUMENT_UPLOAD:
    //   return mandatoryUpload(state, action);
    case actionTypes.STORE_PROPOSAL_FORM_SUCCESS:
      return storeProposalFormData(state, action);
    // case actionTypes.PROPOSAL_FORM_FILLING_LIFEINSURANCE:
    //   return proposalFormFilling(state, action);
    // case actionTypes.PROPOSAL_ID:
    //   return proposalId(state, action);
    // case actionTypes.EDIT_PROPOSAL_FORM_DATA:
    //   return editProposalFormData(state, action);
    default:
      return state;
  }
};

export default reducer;
